<template>
  <div id="active-hold-grid">
    <v-toolbar
      flat
    >
      <v-toolbar-title class="text-h5 pa-0">Funding Soon</v-toolbar-title>
    </v-toolbar>
    <v-row>

      <v-col
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <v-card
          height="100%"
          class="d-flex flex-column justify-start"
        >
          <v-card
            tile
          >
            <v-img
              aspect-ratio="1"
              :src="require('../assets/1958-volkswagen-deluxe-micro-bus-34.jpg')"
              alt="asset-title"
              class="flex-grow-0"
            ></v-img>
          </v-card>

          <v-card-title class="text-center justify-center">1958 VW Samba Bus 23W</v-card-title>

          <v-card-text class="text-center">
            <div>
              Funding Soon
            </div>
          </v-card-text>

          <v-card-actions class="mt-auto flex-wrap justify-center">
            <v-btn class="mt-auto text-center"
            href="mailto:info@bluechipcar.com?subject=BlueChipCar: 1958 VW Samba Bus 23W">
              Contact Us<br />For More Information
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <v-card
          height="100%"
          class="d-flex flex-column justify-start"
        >
          <v-card
            tile
          >
            <v-img
              aspect-ratio="1"
              :src="require('../assets/1948-Alfa-Romeo-6C-2500.jpg')"
              alt="asset-title"
              class="flex-grow-0"
            ></v-img>
          </v-card>

          <v-card-title class="text-center justify-center">1948 Alfa Romeo 6C 2500</v-card-title>

          <v-card-text class="text-center">
            <div>
              Funding Soon
            </div>
          </v-card-text>

          <v-card-actions class="mt-auto flex-wrap justify-center">
            <v-btn class="mt-auto text-center"
            href="mailto:info@bluechipcar.com?subject=BlueChipCar: 1948 Alfa Romeo 6C 2500">
              Contact Us<br />For More Information
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <v-card
          height="100%"
          class="d-flex flex-column justify-start"
        >
          <v-card
            tile
          >
            <v-img
              aspect-ratio="1"
              :src="require('../assets/1948-Cisitalia-202-Cabriolet.jpg')"
              alt="asset-title"
              class="flex-grow-0"
            ></v-img>
          </v-card>

          <v-card-title class="text-center justify-center">1948 Cisitalia 202 Cabriolet</v-card-title>

          <v-card-text class="text-center">
            <div>
              Funding Soon
            </div>
          </v-card-text>

          <v-card-actions class="mt-auto flex-wrap justify-center">
            <v-btn class="mt-auto text-center"
            href="mailto:info@bluechipcar.com?subject=BlueChipCar: 1948 Cisitalia 202 Cabriolet">
              Contact Us<br />For More Information
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <v-card
          height="100%"
          class="d-flex flex-column justify-start"
        >
          <v-card
            tile
          >
            <v-img
              aspect-ratio="1"
              :src="require('../assets/1968-Lamborghini-Islero-400GT.jpg')"
              alt="asset-title"
              class="flex-grow-0"
            ></v-img>
          </v-card>

          <v-card-title class="text-center justify-center">1968 Lamborghini Islero 400GT</v-card-title>

          <v-card-text class="text-center">
            <div>
              Funding Soon
            </div>
          </v-card-text>

          <v-card-actions class="mt-auto flex-wrap justify-center">
            <v-btn class="mt-auto text-center"
            href="mailto:info@bluechipcar.com?subject=BlueChipCar: 1968 Lamborghini Islero 400GT">
              Contact Us<br />For More Information
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>
  </div>
</template>

<script>

  export default {
    name: 'ActiveHoldGrid',
  }
</script>
